export const INAPP_BROWSER_TOOLBAR_COLOR = '#0F2D64' as const;

// Record types as used by TYPO3/Middleware
// and related entity configuration
export const ENTITIES = {
  CLASSIFIED: {
    TYPE: 'classified',
    PATH: 'classifieds',
  },
  EVENT: {
    TYPE: 'event',
    PATH: 'events',
  },
  HINT: {
    TYPE: 'hint',
    PATH: 'notes',
  },
  NEWS: {
    TYPE: 'news',
    PATH: 'news',
  },
  PAGE: {
    TYPE: 'page',
    PATH: 'pages',
  },
} as const;

// Content element names as used by TYPO3/Middleware
export const T3_CONTENT_ELEMENT_NAMES = {
  ACCORDION_CONTAINER: 'grid-accordion-container',
  CAMPAIGN_TEASER: 'apiCampaignTeaserSlider',
  HOME_TILES: 'apiTeaser',
  TEXT_MEDIA: 'textmedia',
} as const;

// Search configuration
export const SEARCH_CONFIG = {
  FOCUS_DELAY_MS: 500,
  MIN_QUERY_LENGTH: 3,
  CLEAR_FOCUS_DELAY_MS: 500,
} as const;

// Stories configuration
export const STORIES_CONFIG = {
  PROGRESS_BAR_RESET_DELAY_MS: 10,
  SWIPER_TRANSITION_SPEED_MS: 400,
  SLIDE_CHANGE_DELAY_MS: 50,
  MILLISECONDS_PER_SECOND: 1000, // For slide_duration conversion
  SWIPER_LOOP_THRESHOLD: 3, // Minimum slides for loop mode
} as const;

// Notification configuration
export const NOTIFICATION_CONFIG = {
  DEBOUNCE_DELAY_MS: 100,
} as const;

// Scroll configuration
export const SCROLL_CONFIG = {
  LOAD_MORE_THRESHOLD_PX: 300,
} as const;

// HTTP status codes
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
} as const;

// Search API configuration
export const SEARCH_API_CONFIG = {
  DEFAULT_LIMIT: 10,
} as const;

// Matomo configuration
export const MATOMO_CONFIG = {
  SITE_ID: '122',
  TRACKER_URL: 'https://webstatistik.uk-koeln.de/matomo.php',
  VISITOR_ID_LENGTH: 16,
} as const;

// Base wrapper configuration
export const BASE_WRAPPER_CONFIG = {
  MODAL_SHOW_DELAY_MS: 10,
  /** Delay after cookie consent so ion-alert can present above the dismissed banner */
  POST_CONSENT_MODAL_DELAY_MS: 300,
  REDIRECT_DELAY_MS: 100,
} as const;

// Ticker animation configuration
export const TICKER_ANIMATION_CONFIG = {
  OVERFLOW_THRESHOLD_PX: 2,
  BASE_SPEED_PX_PER_SEC: 50,
  MIN_DURATION_SECONDS: 3,
  INITIAL_SCROLL_DURATION_SECONDS: 10,
} as const;

// MSAL authentication configuration
export const MSAL_CONFIG = {
  SCOPES: {
    BASIC: 'User.Read',
    FULL: 'User.Read openid profile offline_access',
  },
  STORAGE_KEYS: {
    LOGIN_STATE: 'msal.login.state',
    LOGIN_NONCE: 'msal.login.nonce',
    LOGIN_CODE_VERIFIER: 'msal.login.codeVerifier',
    USER: 'msal.user',
    RETURN_URL: 'msal.returnUrl',
  },
  TOKEN: {
    TYPE: 'Bearer',
    VALIDATION_BUFFER_MS: 5 * 60 * 1000, // 5 minutes
  },
  PKCE: {
    CODE_CHALLENGE_METHOD: 'S256',
    RANDOM_STRING_LENGTHS: {
      STATE: 32,
      NONCE: 32,
      CODE_VERIFIER: 128,
    },
  },
  GRANT_TYPE: {
    AUTHORIZATION_CODE: 'authorization_code',
    REFRESH_TOKEN: 'refresh_token',
  },
  JWT: {
    TOKEN_PAYLOAD_INDEX: 1, // JWT token structure: header(0).payload(1).signature(2)
    HEXADECIMAL_BASE: 16, // For hex encoding
  },
  TIME: {
    MILLISECONDS_PER_SECOND: 1000, // Convert seconds to milliseconds
  },
} as const;
